import React, { useRef, useState } from 'react';
import MyButton from '../../../components/MyButton';

/**
 * Шаг 2: загрузка ответа модели — файлом или вставкой текста.
 */
function BulkUploadPanel({
  value,
  onChange,
  onSubmit,
  loading,
  error,
  disabled,
  disabledText,
  placeholder = 'Вставьте JSON с массивом offers…',
}) {
  const fileInput = useRef();
  const [fileName, setFileName] = useState('');
  const [readError, setReadError] = useState('');

  const onFileSelect = (ev) => {
    const file = ev.target.files?.[0];
    ev.target.value = '';
    if (!file) return;

    setReadError('');
    const reader = new FileReader();
    reader.onload = () => {
      setFileName(file.name);
      onChange(String(reader.result || ''));
    };
    reader.onerror = () => setReadError('Не удалось прочитать файл.');
    reader.readAsText(file);
  };

  return (
    <div className="bulk_offers_panel">
      <p className="bulk_offers_panel_title">Ответ модели</p>
      <p className="bulk_offers_field_note">
        Загрузите файл с ответом модели (.json или .txt) или вставьте текст — блок ```json … ``` тоже подойдёт.
      </p>

      {disabled ? (
        <p className="bulk_offers_notice">{disabledText}</p>
      ) : null}

      <div className="bulk_offers_field_inline">
        <MyButton
          text="Выбрать файл"
          onClick={() => fileInput.current?.click()}
          secondary
          className="bulk_offers_upload_button"
          disabled={disabled}
        />
        <p className="bulk_offers_field_note">{fileName || 'Файл не выбран'}</p>
      </div>
      <input
        ref={fileInput}
        type="file"
        accept=".json,.txt,application/json,text/plain"
        className="bulk_offers_file_input"
        onChange={onFileSelect}
      />

      <textarea
        className="bulk_offers_textarea"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={12}
        spellCheck={false}
        disabled={disabled}
      />

      {readError ? <p className="bulk_offers_error">{readError}</p> : null}
      {error ? <p className="bulk_offers_error">{error}</p> : null}

      <MyButton
        text="Обработать"
        onClick={onSubmit}
        loading={loading}
        disabled={disabled || !value.trim().length}
        className="bulk_offers_wide_button"
      />
    </div>
  );
}

export default BulkUploadPanel;
